module.exports = __webpack_public_path__ + "static/media/remove.19ec4551.svg";